// extracted by mini-css-extract-plugin
export default {"form":"sidebarForm_form__mFsRn","inner":"sidebarForm_inner__QyWV-","body":"sidebarForm_body__dmPkq","vertical":"sidebarForm_vertical__mvra3","footer":"sidebarForm_footer__pN4uh"};